// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"428":"64032f19","640":"60335d36","709":"cd64233f","895":"aa225041"}[chunkId] + ".css";
};